// extracted by css-extract-rspack-plugin
export default {"container":"QuotaExceededBanner-module__container__NIS6d"};